<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)) {
      // 移动端
      console.log("ok");
    } else {
      // PC端
      window.location.href = "https://www.lljrtj.com/"
    }
  }
}


</script>

<style>
* {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue